import { render, staticRenderFns } from "./webtab.vue?vue&type=template&id=6a1306a6&"
import script from "./webtab.vue?vue&type=script&lang=js&"
export * from "./webtab.vue?vue&type=script&lang=js&"
import style0 from "./webtab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports